<div mat-dialog-title="">
  <div class="flex justify-between content-center items-center flex-row flex-wrap gap-[1rem]">
    <div>
      <h3 class="mat-h2 m0" translate="">Tax partner</h3>
    </div>
    @if (!this.person) {
      <div>
        <unite-customer-autocomplete type="Person" [label]="'Search' | translate" [control]="searchGroup.get('customer')" class="max-lg:basis-full lg:basis-1/2 lg:grow-0 lg:shrink-0"></unite-customer-autocomplete>
      </div>
    }
  </div>
  <mat-divider></mat-divider>
</div>

@if (isLoading) {
  <mat-dialog-content class="flex flex-col">
    <div class="flex flex-col justify-start items-center w-full">
      <div><mat-spinner diameter="18" class="gray"></mat-spinner></div>
      <div class="ml1" translate="">Loading contact</div>
    </div>
  </mat-dialog-content>
}

@if (!isLoading) {
  <mat-dialog-content class="flex flex-col">
    <form [formGroup]="personGroup">
      <div class="flex flex-col w-full">
        <mat-radio-group formControlName="gender" required="" class="mb2 py1 ">
          <mat-radio-button value="Male" color="primary" class="mr2"><span translate="">Mr.</span></mat-radio-button>
          <mat-radio-button value="Female" color="primary" class="mr2"><span translate="">Mrs.</span></mat-radio-button>
        </mat-radio-group>
        <mat-form-field appearance="outline" class="small-field">
          <mat-label translate="">Initials</mat-label>
          <input matInput="" type="text" formControlName="initials" minLength="1" required="" autocomplete="off">
        </mat-form-field>
        <div class="flex flex-row space-x-[3%]">
          <mat-form-field appearance="outline" class="basis-2/5">
            <mat-label translate="">First name</mat-label>
            <input matInput="" type="text" formControlName="firstName" minlength="1" required="" autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="basis-1/5">
            <mat-label translate="">Middle name</mat-label>
            <input matInput="" type="text" formControlName="middleName" placeholder="" minlength="1" autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="basis-2/5">
            <mat-label translate="">Surname</mat-label>
            <input matInput="" type="text" formControlName="surname" placeholder="" minlength="1" required="" autocomplete="off">
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="small-field">
          <mat-label translate="">Birthdate</mat-label>
          <input matInput="" [matDatepicker]="picker" formControlName="birthdate" autocomplete="off">
          <mat-datepicker-toggle matSuffix="" [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker=""></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label translate="">Email</mat-label>
          <input matInput="" email="" type="email" formControlName="email" autocomplete="off">
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
}

@if (!isLoading) {
  <mat-dialog-actions class="flex justify-start items-center flex-row gap-[1rem]">
    <button mat-button="" mat-dialog-close="">
      <span translate="">
        Cancel
      </span>
    </button>
    <unite-loading-button [text]="'Save' | translate" icon="edit" [loading]="isSaving" (click)="save()">
    </unite-loading-button>
  </mat-dialog-actions>
}
